(function () {
  "use strict";

  var root = document.querySelector("[data-arpro-tariff-root]");
  if (!root) return;

  var allowedModes = ["trad", "grossistes"];
  var serverMode = root.dataset.arproCurrentMode;
  var hasAuthorizedMode = allowedModes.indexOf(serverMode) !== -1;
  var requestedStatus = root.querySelector("[data-arpro-tariff-requested-status]");

  function requestedModeCopy(mode, submitted) {
    if (mode === "trad") {
      return submitted
        ? "Demande transmise : TARIFS TRAD HT — en attente de validation par l’ADV."
        : "Préférence sélectionnée : TARIFS TRAD HT — demande non envoyée.";
    }

    if (mode === "grossistes") {
      return submitted
        ? "Demande transmise : TARIFS GROSSISTE FR HT — en attente de validation par l’ADV."
        : "Préférence sélectionnée : TARIFS GROSSISTE FR HT — demande non envoyée.";
    }

    if (mode === "review") {
      return submitted
        ? "Demande de conseil transmise à l’ADV."
        : "Conseil sélectionné — demande non envoyée.";
    }

    return "";
  }

  function applyRequestedMode(mode, submitted) {
    root.querySelectorAll("[data-arpro-tariff-choice]").forEach(function (choice) {
      choice.classList.remove("is-requested");
      choice.removeAttribute("data-arpro-tariff-requested");
    });

    if (hasAuthorizedMode) {
      if (requestedStatus) {
        requestedStatus.hidden = true;
        requestedStatus.textContent = "";
      }
      return;
    }

    var copy = requestedModeCopy(mode, submitted);
    var requestedChoice = allowedModes.indexOf(mode) !== -1
      ? root.querySelector('[data-arpro-tariff-choice="' + mode + '"]')
      : null;

    if (requestedChoice) {
      requestedChoice.classList.add("is-requested");
      requestedChoice.setAttribute("data-arpro-tariff-requested", "true");
    }

    if (requestedStatus) {
      requestedStatus.textContent = copy;
      requestedStatus.hidden = !copy;
    }
  }

  function applyServerContext() {
    if (hasAuthorizedMode) {
      document.documentElement.dataset.arproTariffMode = serverMode;
    } else {
      delete document.documentElement.dataset.arproTariffMode;
    }

    document.querySelectorAll("[data-arpro-mode-copy]").forEach(function (copy) {
      copy.hidden = !hasAuthorizedMode || copy.dataset.arproModeCopy !== serverMode;
    });

    document.querySelectorAll("[data-arpro-tariff-short]").forEach(function (label) {
      label.textContent = hasAuthorizedMode
        ? (serverMode === "grossistes" ? "GROSSISTES" : "TRAD")
        : "ACCÈS PRO";
    });

    root.dataset.arproEnhanced = "true";
  }

  applyServerContext();
  applyRequestedMode(
    document.documentElement.dataset.arproRequestedTariffMode || "",
    document.documentElement.dataset.arproTariffRequestState === "submitted"
  );

  document.addEventListener("arpro:tariff-requested", function (event) {
    var mode = event.detail && event.detail.mode ? event.detail.mode : "";
    applyRequestedMode(mode, Boolean(event.detail && event.detail.submitted));
  });
})();
